import { Button, Typography } from '@material-ui/core'
import { parse } from 'query-string'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import Table, { TableColumn } from '../components/Table'
import http from '../http'
import { OrderContext } from '../OrderContext'
import { getDate } from '../util'
import { ReturnsListContext } from './ReturnsListContext'

type OrderDetail = {
    netValue: string,
    currency: string,
    unitprice: string,
    material: string,
    batch: string
    lineItemNumber: string,
    materialDescription: string,
    orderQuantity: string,
    refDocument: string
}

const ReturnDetail = () => {
    const { t } = useTranslation()
    const { orders, loading: listLoading } = useContext(ReturnsListContext)
    const { customer } = useContext(OrderContext)
    const history = useHistory()
    const location = useLocation()
    const orderNumber = useMemo(() => parse(location.search).number, [location.search])
    const [data, setData] = useState<OrderDetail[]>([])
    const [loading, setLoading] = useState<boolean>(true)

    const order = useMemo(() => orders?.find(o => o.documentNumber === orderNumber), [orders, orderNumber])

    useEffect(() => {
        setLoading(true)
        setData([])

        http.get<OrderDetail[]>(`api/OrderList/Details?documentNumber=${encodeURIComponent(orderNumber as string)}`)
            .then(({ data }) => setData(data))
            .catch(console.log)
            .finally(() => setLoading(false))
    }, [orderNumber])

    const columns: TableColumn<OrderDetail>[] = [
        { title: t('material_number'), property: 'material' },
        { title: t('item'), property: 'materialDescription', flex: 3 },
        { title: t('unit_price_in', { currency: customer.currency }), property: 'unitprice', render: (p, r) => `${parseFloat(p as string).toFixed(2)}` },
        { title: t('quantity'), property: 'orderQuantity' },
        { title: t('amount_in', { currency: customer.currency }), property: 'netValue' },
    ]

    return (
        <>
            <Button color='primary' onClick={() => history.push('/')}>&lt;&lt; {t('back_to_list')}</Button>
            <Typography variant='h4'>{t('order')} {orderNumber}</Typography>

            <p><b>{t('order_date')}:</b> {getDate(order?.orderDate, customer.language)}</p>
            <p><b>{t('order_type')}:</b> {order?.type}</p>
            <p><b>{t('status')}:</b> {order?.status}</p>
            <p><b>{t('tracking')}:</b> {order?.trackingURL ? <a href={order?.trackingURL} target='_blank' rel='noopener noreferrer'>{order?.trackingURL}</a> : listLoading ? undefined : t('not_available')}</p>

            <Table columns={columns} data={data} loading={loading} />
        </>
    )
}

export default ReturnDetail
